var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFilterHorizontalFilled = function SvgFilterHorizontalFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2563EB",
    d: "M8.666 2c-1.242 0-2.286.85-2.582 2H2a.667.667 0 0 0 0 1.333h4.084c.296 1.15 1.34 2 2.582 2h.667a2.667 2.667 0 1 0 0-5.333h-.667ZM13.333 4a.667.667 0 1 0 0 1.333H14A.667.667 0 1 0 14 4h-.667ZM6 8.667c-1.243 0-2.287.85-2.583 2H2A.667.667 0 1 0 2 12h1.417c.296 1.15 1.34 2 2.583 2h.666a2.667 2.667 0 0 0 0-5.333H6ZM10.666 10.667a.667.667 0 1 0 0 1.333H14a.667.667 0 0 0 0-1.333h-3.334Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFilterHorizontalFilled);
export default ForwardRef;